/** Runs jobs one at a time in call order; a failed job does not block the ones queued behind it. */
export const createSerialQueue = (): (<T>(
  job: () => Promise<T>
) => Promise<T>) => {
  let tail: Promise<unknown> = Promise.resolve();
  return <T>(job: () => Promise<T>): Promise<T> => {
    const result = tail.then(job);
    tail = result.catch((): void => undefined);
    return result;
  };
};
